import * as emailsApi from '../../api/emailsApi/files';
import { sha256 } from 'js-sha256';

const toMappedFiles = (docrioNamespace = 'litify_docs') => (mappings, file) => {
  const folderPath = JSON.parse(file?.[`${docrioNamespace}__Folder_Path__c`] || '[]').join('/');
  return { ...mappings,
    [folderPath]: Array.isArray(mappings[folderPath]) ? [...mappings[folderPath], file] : [file],
  };
};

export const loadFiles = async (recordId, nextBatch, docrioNamespace) => {
  const data = await emailsApi.getFiles(recordId, nextBatch);
  return { mappedFiles: data.Records.reduce(toMappedFiles(docrioNamespace), { }), nextFileBatch: data?.NextBatch };
};

export const calculateAttachmentHash = (contentBytes, name) => {
  return sha256(contentBytes + name);
};
